import React, { useEffect, useMemo, useState } from "react";
import { Eye, Trash2, Search } from "lucide-react";
import "./Cutomer.css";
import { adminApi } from "../../utils/adminApi";

const formatBookingId = (order = {}) => {
  if (order.trackingId) return order.trackingId;
  return `#CS-${String(order._id || "").slice(-6).toUpperCase()}`;
};

const Customers = () => {
  const [bookings, setBookings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchBookings = async () => {
    const res = await adminApi.get("/api/bookings");
    setBookings(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const customers = useMemo(() => {
    const grouped = new Map();

    bookings.forEach((booking) => {
      const key = (booking.phone || "").trim() || booking._id;
      const existing = grouped.get(key);

      if (!existing) {
        grouped.set(key, {
          id: key,
          name: booking.name || "Unknown",
          phone: booking.phone || "-",
          email: booking.email || "-",
          orders: 1,
          latestBooking: booking,
          bookingIds: [booking._id],
        });
        return;
      }

      existing.orders += 1;
      existing.bookingIds.push(booking._id);
      const existingDate = new Date(existing.latestBooking?.createdAt || 0).getTime();
      const currentDate = new Date(booking?.createdAt || 0).getTime();
      if (currentDate > existingDate) {
        existing.latestBooking = booking;
        existing.name = booking.name || existing.name;
        existing.email = booking.email || existing.email;
      }
    });

    return Array.from(grouped.values());
  }, [bookings]);

  const filteredCustomers = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return customers;

    return customers.filter((c) => {
      const searchableText = [
        c.name,
        c.phone,
        c.email,
        formatBookingId(c.latestBooking),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(q);
    });
  }, [customers, searchTerm]);

  const viewCustomer = (customer) => {
    const latest = customer.latestBooking || {};
    const msg = `Booking ID: ${formatBookingId(latest)}\nName: ${customer.name}\nPhone: ${customer.phone}\nEmail: ${
      customer.email || "-"
    }\nOrders: ${customer.orders}\nLast Device: ${latest.brand || "-"} ${
      latest.model || "-"
    }\nLast Service: ${latest.service || "-"}`;
    alert(msg);
  };

  const deleteCustomer = async (customer) => {
    if (!window.confirm("Delete all bookings for this customer?")) return;
    await Promise.all(
      customer.bookingIds.map((id) => adminApi.delete(`/api/bookings/${id}`))
    );
    fetchBookings();
  };
const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(10);
const total = filteredCustomers.length;

const startIndex = (currentPage - 1) * rowsPerPage;
const endIndex = startIndex + rowsPerPage;

const paginatedCustomers = filteredCustomers.slice(startIndex, endIndex);

const totalPages = Math.ceil(total / rowsPerPage);
  return (
    <div className="customers-page">
      <h1 className="customers-title">Customers</h1>

      <div className="customers-card">
<div className="customers-search-wrapper">
  <Search size={18} className="customers-search-icon-fixed" />
  
  <input
    type="text"
    placeholder="Search booking ID, name, phone, email..."
    className="customers-search-input-surgical"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

        <table className="customers-table">
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Orders</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCustomers.length > 0 ? (
             paginatedCustomers.map((c) => (
                <tr key={c.id}>
                  <td data-label="Booking ID">{formatBookingId(c.latestBooking)}</td>
                  <td data-label="Name" className="customers-name">
                    {c.name}
                  </td>
                  <td data-label="Phone">{c.phone}</td>
                  <td data-label="Email">{c.email || "-"}</td>
                  <td data-label="Orders">{c.orders}</td>
                  <td data-label="Action">
                    <div className="customers-actions">
                      <button className="customers-btn view" onClick={() => viewCustomer(c)}>
                        <Eye size={16} />
                      </button>
                      <button
                        className="customers-btn delete"
                        onClick={() => deleteCustomer(c)}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="customers-empty">
                  No customers found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="customers-pagination">
  <div>
    Showing {total === 0 ? 0 : startIndex + 1}–
    {Math.min(endIndex, total)} of {total}
  </div>

  <div className="customers-pagination-right">
    <select
      value={rowsPerPage}
      onChange={(e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
      }}
    >
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={25}>25</option>
    </select>

    <button
      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    <span>
      Page {currentPage} / {totalPages || 1}
    </span>

    <button
      onClick={() =>
        setCurrentPage((p) => Math.min(p + 1, totalPages))
      }
      disabled={currentPage === totalPages || totalPages === 0}
    >
      Next
    </button>
  </div>
</div>
      </div>
    </div>
  );
};

export default Customers;
